import InfoIcon from "@mui/icons-material/Info";
import { Box, IconButton, TextField, Tooltip } from "@mui/material";

interface IntWellVolProps {
  intWellVol: number | null;
  operatingVol: number;
}

export const IntWellVol = ({ intWellVol, operatingVol }: IntWellVolProps) => {
  const isGreaterThanOperatingVol = () => {
    if (!intWellVol || !operatingVol) {
      return false;
    }
    return intWellVol > operatingVol;
  };

  return (
    <TextField
      sx={{ width: "50%", marginTop: "10px", marginRight: "5px" }}
      id={"int-well-vol"}
      label={
        <Box sx={{ display: "inline-flex", alignItems: "center" }}>
          Int Well Vol (µL)
          <Tooltip
            arrow
            placement="top"
            title="Calculated by subtracting total Dead Aliquot Volume from Pellet Resuspension Volume."
          >
            <IconButton size="small">
              <InfoIcon fontSize="small" />
            </IconButton>
          </Tooltip>
        </Box>
      }
      value={intWellVol}
      variant="outlined"
      size={"medium"}
      type="number"
      error={isGreaterThanOperatingVol()}
      helperText={
        isGreaterThanOperatingVol() && "Cannot be greater than Operating Vol"
      }
      InputLabelProps={{
        shrink: intWellVol !== null,
      }}
      disabled={true}
    />
  );
};
